import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { CompanyOrPublicRouteGuard } from './auth/company-or-public-route-guard';

import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';
import { CopyToClipboardDirective } from '@shared/directives/copy-to-clipboard.directive';

const sharedExportedElements = [CopyToClipboardDirective, BusyDirective, EqualValidator];

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [...sharedExportedElements],
    exports: [...sharedExportedElements],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [AppSessionService, AppUrlService, AppAuthService, AppRouteGuard, CompanyOrPublicRouteGuard],
        };
    }
}
